import { render, staticRenderFns } from "./Resolves.vue?vue&type=template&id=402b59e7"
import script from "./Resolves.vue?vue&type=script&lang=ts"
export * from "./Resolves.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports